import React from 'react';
import ReactDOM from 'react-dom';
import Amplify from 'aws-amplify';
import { applyMiddleware, createStore } from 'redux';
import { composeWithDevTools } from 'redux-devtools-extension';
import { createMuiTheme, MuiThemeProvider } from '@material-ui/core/styles';
import { BrowserRouter as Router } from 'react-router-dom';
import ReduxThunk from 'redux-thunk';
import { Provider } from 'react-redux';
import config from './config';
import reducers from './reducer';
import App from './App';

import './index.scss';

const store = createStore(
  reducers,
  composeWithDevTools(applyMiddleware(ReduxThunk))
);

const theme = createMuiTheme({
  palette: {
    type: 'dark'
  },
  typography: {
    useNextVariants: true
  }
});

Amplify.configure({
  Auth: {
    mandatorySignIn: false,
    region: config.cognito.REGION,
    userPoolId: config.cognito.USER_POOL_ID,
    identityPoolId: config.cognito.IDENTITY_POOL_ID,
    userPoolWebClientId: config.cognito.APP_CLIENT_ID
  }
})

ReactDOM.render(
  <Router>
    <Provider store={ store }>
      <MuiThemeProvider theme={ theme }>
        <App />
      </MuiThemeProvider>
    </Provider>
  </Router>,
  document.getElementById('root')
);